<template>
	<div class="container">
		<el-card>
			<div slot="header">开户记录查询</div>
			<div style="height: 100%">
				<div style="padding: 0px">
					<el-button @click="openAccount" size="small">商户开户</el-button>
					<el-button @click="editAccount" icon="el-icon-edit" style="background-color: #1abc9c !important"
						size="small">编辑</el-button>
					<el-button class="iconfont icon-excel" @click="exportToExcel"
						style="background-color: #23c6c8 !important" size="small">导出</el-button>
					<el-button class="iconfont icon-excel" @click="handleViewDetail"
						style="background-color: #23c6c8 !important" size="small">查看详情</el-button>
				</div>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
					<el-form-item label="创建时间" label-width="70px">
						<el-date-picker v-model="queryParams.createStartTime" type="datetime" placeholder="选择开始日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
						<label> 到 </label>
						<el-date-picker v-model="queryParams.createEndTime" type="datetime" placeholder="选择结束日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="商户编号">
						<el-input v-model="queryParams.code" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-select v-model="queryParams.name" placeholder="" clearable filterable>
							<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="handleQuery" size="small"
						style="margin-left: 10px">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table ref="openAccountRecordTable" :data="tableData" style="width: 100%" height="92%"
						highlight-current-row id="openAccountRecordTable" @current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" align="center">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" width="150" align="center">
						</el-table-column>
						<el-table-column prop="code" label="商户编号" align="center">
						</el-table-column>
						<el-table-column prop="name" label="商户名称" width="180" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="电话" align="center">
						</el-table-column>
						<el-table-column prop="detailAddress" label="联系地址" width="300" align="center">
						</el-table-column>
						<el-table-column prop="modifyTime" label="修改时间" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
		<!-- 编辑用户信息 -->
		<el-dialog title="编辑用户信息" :visible.sync="editDialogVisible" width="1000px" class="editDialogClass">
			<el-form ref="recordForm" :model="recordForm" :rules="recordFormRules" label-width="150px">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="商户编号" prop="code">
							<el-input v-model="recordForm.code" placeholder="" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="商户名称" prop="name">
							<el-input v-model="recordForm.name"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="商户联系人" prop="contactMan">
							<el-input v-model="recordForm.contactMan"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电话" prop="phone">
							<el-input v-model="recordForm.phone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="区域" prop="districtId">
							<el-cascader v-model="recordForm.districtId" :options="districtIdOptions" :props="props"
								clearable></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="地址" prop="address">
							<el-input v-model="recordForm.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :md="2">
						<el-form-item label="开启电账户" label-width="100px">
							<el-checkbox v-model="recordForm.enableElectricAccountFlag" true-label="1" false-label="0"
								@change="electricAccountFlagChange"></el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :md="10">
						<el-form-item label="电费价格" label-width="130px">
							<el-input v-model="recordForm.electricPrice" clearable :disabled="electricAccountFlag">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :md="2">
						<el-form-item label="开启水账户" label-width="100px">
							<el-checkbox v-model="recordForm.enableWaterAccountFlag" true-label="1" false-label="0"
								@change="waterAccountFlagChange">
							</el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :md="10">
						<el-form-item label="水费价格" label-width="130px">
							<el-input v-model="recordForm.waterPrice" clearable :disabled="waterAccountFlag">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :md="2">
						<el-form-item :label="electricUniServiceFeeColumnName" label-width="100px">
							<el-checkbox v-model="recordForm.electricPriceServiceFeeUniFlag" true-label="1" false-label="0" :disabled="electricAccountFlag"></el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :md="10">
						<el-form-item :label="electricServiceFeePriceColumnName" label-width="130px">
							<el-input v-model="recordForm.electricPriceServiceFee" clearable :disabled="electricAccountFlag">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :md="2">
						<el-form-item :label="waterUniServiceFeeColumnName" label-width="100px">
							<el-checkbox v-model="recordForm.waterPriceServiceFeeUniFlag" true-label="1" false-label="0" :disabled="waterAccountFlag">
							</el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :md="10">
						<el-form-item :label="waterServiceFeePriceColumnName" label-width="130px">
							<el-input v-model="recordForm.waterPriceServiceFee" clearable :disabled="waterAccountFlag">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="小程序联系人" prop="systemAdmin">
							<el-input v-model="recordForm.systemAdmin"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电话" prop="systemAdminPhone">
							<el-input v-model="recordForm.systemAdminPhone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="商户电账户当前金额" prop="">
							<!-- 	<el-input v-model="recordForm.electricBalance"
								oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')">
							</el-input> -->
							<el-input v-model="recordForm.electricBalance"  disabled>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="商户水账户当前金额" prop="">
							<!-- <el-input v-model="recordForm.waterBalance"
								oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')">
							</el-input> -->
							<el-input v-model="recordForm.waterBalance" disabled>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="业态" prop="type">
							<el-select v-model="recordForm.type" placeholder="请选择" style="width: 100%">
								<el-option v-for="item in lesseeTypeOptions" :key="item.key" :label="item.value"
									:value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="recordForm.remark"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-button type="primary" @click="addElectricMeterDialog" :disabled="electricAccountFlag">新增商户电表
						</el-button>
					</el-col>
					<el-col :span="12">
						<el-button type="primary" @click="addWaterMeterDialog" :disabled="waterAccountFlag">新增商户水表
						</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-row :gutter="20" style="margin-top: 5px">
				<el-col :span="12">
					<el-table :data="electricTableData" style="width: 100%" border>
						<el-table-column prop="meterAddr" label="电表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="电表型号" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="电表厂商" align="center">
						</el-table-column>
						<el-table-column prop="type" label="电表制式" align="center">
						</el-table-column>
						<el-table-column prop="startDegree" label="开始度数(kW·h)" align="center">
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="text" icon="el-icon-delete"
									@click="handleDeleteRow(scope.$index, electricTableData)" class="deleteStyle">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="12">
					<el-table :data="waterTableData" style="width: 100%" border>
						<el-table-column prop="meterAddr" label="水表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="水表型号" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="水表厂商" align="center">
						</el-table-column>
						<el-table-column prop="startDegree" label="起始水底数(m³)" align="center">
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="text" icon="el-icon-delete"
									@click="handleDeleteRow(scope.$index, waterTableData)" class="deleteStyle">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editSaveClick">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 查看详情 -->
		<el-dialog title="查看详情" :visible.sync="detailDialogVisible" width="1000px" class="detailDialogClass">
			<div>
				<el-form ref="recordForm" :model="recordForm" label-width="150px" size="small">
					<el-row :gutter="10">
						<el-col :span="12">
							<el-form-item label="商户编号" prop="code">
								<el-input v-model="recordForm.code" placeholder="" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="商户名称" prop="name">
								<el-input v-model="recordForm.name" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-form-item label="商户联系人" prop="contactMan">
								<el-input v-model="recordForm.contactMan" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="电话" prop="phone">
								<el-input v-model="recordForm.phone" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-form-item label="区域" prop="districtId">
								<el-cascader v-model="recordForm.districtId" :options="districtIdOptions" :props="props"
									disabled></el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="地址" prop="address">
								<el-input v-model="recordForm.address" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="2">
							<el-form-item label="开启电账户" label-width="100px">
								<el-checkbox v-model="recordForm.enableElectricAccountFlag" true-label="1" false-label="0" disabled></el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item label="电费价格" label-width="130px">
								<el-input v-model="recordForm.electricPrice"  disabled>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :md="2">
							<el-form-item label="开启水账户" label-width="100px">
								<el-checkbox v-model="recordForm.enableWaterAccountFlag" true-label="1" false-label="0" disabled>
								</el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item label="水费价格" label-width="130px">
								<el-input v-model="recordForm.waterPrice" disabled>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="2">
							<el-form-item :label="electricUniServiceFeeColumnName" label-width="100px">
								<el-checkbox v-model="recordForm.electricPriceServiceFeeUniFlag" true-label="1" false-label="0" disabled></el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item :label="electricServiceFeePriceColumnName" label-width="130px">
								<el-input v-model="recordForm.electricPriceServiceFee"  disabled>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :md="2">
							<el-form-item :label="waterUniServiceFeeColumnName" label-width="100px">
								<el-checkbox v-model="recordForm.waterPriceServiceFeeUniFlag" true-label="1" false-label="0" disabled>
								</el-checkbox>
							</el-form-item>
						</el-col>
						<el-col :md="10">
							<el-form-item :label="waterServiceFeePriceColumnName" label-width="130px">
								<el-input v-model="recordForm.waterPriceServiceFee" disabled>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-form-item label="小程序联系人" prop="systemAdmin">
								<el-input v-model="recordForm.systemAdmin" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="电话" prop="systemAdminPhone">
								<el-input v-model="recordForm.systemAdminPhone" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-form-item label="商户电账户当前金额" prop="electricBalance">
								<el-input v-model="recordForm.electricBalance" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="业态" prop="type">
								<el-select v-model="recordForm.type" placeholder="请选择" style="width: 100%" disabled>
									<el-option v-for="item in lesseeTypeOptions" :key="item.key" :label="item.value"
										:value="item.key"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-form-item label="商户水账户当前金额" prop="waterBalance">
								<el-input v-model="recordForm.waterBalance" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="备注" prop="remark">
								<el-input v-model="recordForm.remark" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<el-card>
				<div slot="header">已绑定电表信息</div>
				<div>
					<el-table :data="electricTableData" style="width: 100%">
						<el-table-column prop="meterAddr" label="电表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="电表型号" align="center">
						</el-table-column>
						<el-table-column prop="startDegree" label="开始度数(kW·h)" align="center">
						</el-table-column>
						<el-table-column prop="type" label="电表制式" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="电表厂商" align="center">
						</el-table-column>
						<el-table-column prop="ctRatio" label="CT变比" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<el-card>
				<div slot="header">已绑定水表信息</div>
				<div>
					<el-table :data="waterTableData" style="width: 100%">
						<el-table-column prop="meterAddr" label="水表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="水表型号" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="水表厂商" align="center">
						</el-table-column>
						<el-table-column prop="startDegree" label="起始水底数(m³)" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
		</el-dialog>
		<!-- 新增商户电表 -->
		<el-dialog title="新增商户电表" :visible.sync="addElectricVis" width="850px">
			<el-form ref="addElectricForm" :model="addElectricForm" label-width="125px" size="small"
				:rules="addElectricFormRules">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="选择已有编号">
							<el-select v-model="addElectricForm.id" placeholder="请选择" filterable clearable
								@clear="addElectricForm = {}" @change="meterIdChange">
								<el-option v-for="item in meterIdOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-button type="primary" style="margin-left: 30px" @click="addNewElectricMeter">新增电表
						</el-button>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="电表编号">
							<el-input v-model="addElectricForm.meterAddr" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电表型号">
							<el-input v-model="addElectricForm.model" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="电表制式">
							<el-select v-model="addElectricForm.type" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in meterTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电表厂商">
							<el-select v-model="addElectricForm.producer" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in producerOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="终端类型">
							<el-select v-model="addElectricForm.terminalId" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in terminalOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电表接线方式">
							<el-select v-model="addElectricForm.wiringMode" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in wiringModeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="操作者">
							<el-input v-model="addElectricForm.operator" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作密码">
							<el-input v-model="addElectricForm.password" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<!-- <el-col :span="12">
            <el-form-item label="商户地址">
              <el-input
                v-model="addElectricForm.roomAddr"
                :disabled="newMeterFlag"
              ></el-input>
            </el-form-item>
          </el-col> -->
					<el-col :span="12">
						<el-form-item label="备注">
							<el-input v-model="addElectricForm.remark" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="CT变比">
							<el-input v-model="addElectricForm.ctRatio" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item label="开始度数(kW·h)" prop="startDegree">
							<el-input v-model="addElectricForm.startDegree"
								@input="startDegree = addElectricForm.startDegree"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindElectricMeter">绑 定</el-button>
				<el-button @click="addElectricVis = false">返 回</el-button>
			</span>
		</el-dialog>
		<!-- 新增商户水表 -->
		<el-dialog title="新增商户水表" :visible.sync="addWaterVis" width="800px">
			<el-form ref="addWaterForm" :rules="addWaterFormRules" :model="addWaterForm" label-width="125px"
				size="small">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="选择已有编号">
							<el-select v-model="addWaterForm.id" placeholder="请选择" filterable clearable
								@clear="addWaterForm = {}" @change="waterMeterIdChange">
								<el-option v-for="item in waterMeterIdOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-button type="primary" style="margin-left: 30px" @click="addNewWaterMeter">新增水表</el-button>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="水表编号">
							<el-input v-model="addWaterForm.meterAddr" clearable :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="水表型号">
							<el-input v-model="addWaterForm.model" clearable :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="操作者">
							<el-input v-model="addWaterForm.operator" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作密码">
							<el-input v-model="addWaterForm.password" :disabled="newMeterFlag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="水表厂商">
							<el-select v-model="addWaterForm.producer" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in waterProducerOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="终端类型">
							<el-select v-model="addWaterForm.terminalId" placeholder="请选择" clearable
								:disabled="newMeterFlag">
								<el-option v-for="item in terminalWaterOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item label="起始水底数(m³)" prop="startDegree">
							<el-input v-model="addWaterForm.startDegree" clearable
								@input="startDegree = addWaterForm.startDegree"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindWaterMeter">绑 定</el-button>
				<el-button @click="addWaterVis = false">返 回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		translateObjectEmptyAttributeToNull
	} from '../../untils/func';
	import {
		selectList,
		detail,
		meterDetail,
		selectOne,
		addMeter,
		editSave,
		selectOneWater,
		addWaterMeter,
		detailWater,
		systemCustomConfig
	} from '../../api/merchant/openAccountRecord';
	import {
		selectMeterTerminalList,
		selectDictionaryListByName,
		selectUnUseMeter,
		selectMeterProducerList,
		selectUnUseWaterMeter,
		selectWaterProducerList,
		selectComboboxTreeData,
		selectWaterTerminalList,
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import exportTable from '../../untils/exportTable';
	import {
		cascaderAfferentString,
		cascaderAfferentNumber,
		cascaderAfferentArray,
	} from '../../untils/func.js';
	import systemConstant from '../../constant/systemConstant.js'
	export default {
		data() {
			return {
				form: {},
				recordForm: {
					code: '',
					name: '',
					contactMan: '',
					systemAdmin: '',
					phone: '',
					systemAdminPhone: '',
					address: '',
					type: '',
					electricBalance: '',
					waterBalance: '',
					districtId: '',
					districtData: '',
					enableElectricAccountFlag: "1",
					enableWaterAccountFlag: "1",
					electricPrice: '',
					waterPrice: '',
					electricPriceServiceFeeUniFlag: "1",
					waterPriceServiceFeeUniFlag: "1",
					electricPriceServiceFee: '',
					waterPriceServiceFee: ''
				},
				recordFormRules: {
					code: [{
						required: true,
						message: '请输入商户编号',
						trigger: 'blur',
					}, ],
					name: [{
						required: true,
						message: '请输入商户名称',
						trigger: 'blur',
					}, ],
					contactMan: [{
						required: true,
						message: '请输入商户联系人',
						trigger: 'blur',
					}, ],
					systemAdmin: [{
						required: true,
						message: '请输入小程序联系人',
						trigger: 'blur',
					}, ],
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur',
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位手机号码',
							trigger: 'blur',
						},
						{
							pattern: /^\d{11}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
					systemAdminPhone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur',
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位手机号码',
							trigger: 'blur',
						},
						{
							pattern: /^\d{11}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
					type: [{
						required: true,
						message: '请选择业态',
						trigger: 'change',
					}, ],
					districtId: [{
						required: true,
						message: '请选择区域',
						trigger: 'blur',
					}, ],
					electricBalance: [{
							required: true,
							trigger: 'blur',
							message: '请输入商户电账户当前金额',
						},
						// {
						// 	pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
						// 	message: '请输入正确金额格式,可保留两位小数',
						// },
					],
					waterBalance: [{
							required: true,
							trigger: 'blur',
							message: '请输入商户水账户当前金额',
						},
						// {
						// 	pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
						// 	message: '请输入正确金额格式,可保留两位小数',
						// },
					],
				},
				waterProducerOptions: [], //厂商类型options
				// 遮罩层
				loading: true,
				total: 0,
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
					code: '',
					name: '',
					id: '',
				},
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
				lesseeNameOptions: [],
				tableData: [],
				currentRow: null,
				detailDialogVisible: false,
				editDialogVisible: false,
				addElectricVis: false,
				addWaterVis: false,
				addWaterForm: {
					id: '',
					startDegree: '',
				},
				addWaterFormRules: {
					startDegree: [{
						required: true,
						message: '请输入起始水底数',
						trigger: 'blur',
					}, ],
				},
				addElectricForm: {
					id: '',
					startDegree: '',
				},
				addElectricFormRules: {
					startDegree: [{
						required: true,
						message: '请输入开始度数',
						trigger: 'blur',
					}, ],
				},
				newMeterFlag: true,
				electricTableData: [], //电表table数据
				waterTableData: [], //水表table数据
				lesseeTypeOptions: [], //业态 options
				meterIdOptions: [], //已有编号 options
				terminalOptions: [], //电表终端类型options
				terminalWaterOptions: [], //水表终端类型options
				wiringModeOptions: [], //电表接线方式options
				producerOptions: [], //厂商类型options
				meterTypeOptions: [], //电表制式options
				waterMeterIdOptions: [], //未绑定水表 options
				startDegree: null,
				districtIdOptions: [], //区域 options
				props: {
					expandTrigger: 'hover',
				},
				electricAccountFlag: false,
				waterAccountFlag: false,
				electricUniServiceFeeColumnName: '',
				electricServiceFeePriceColumnName: '',
				waterUniServiceFeeColumnName: '',
				waterServiceFeePriceColumnName: '',
			};
		},
		created() {
			this.electricUniServiceFeeColumnName = "统一" + this.$root.serviceFeeNameElectric;
			this.electricServiceFeePriceColumnName = this.$root.serviceFeeNameElectric + "价格" ;
			this.waterUniServiceFeeColumnName = "统一" + this.$root.serviceFeeNameWater;
			this.waterServiceFeePriceColumnName = this.$root.serviceFeeNameWater + "价格" ;
			this.init();
		},
		mounted() {},
		watch: {},
		computed: {},
		methods: {
			async init() {
				await this.handleQuery();
				// 下拉列表数据
				await this.getLesseeType();
				await this.getWiringMode();
				await this.getProducer();
				await this.getSelectWaterProducerList();
				await this.getMeterType();
				await this.getTerminalId();
				await this.selectComboboxTreeData();
				await this.getSelectWaterTerminalList();
				await this.getLesseeNameOption();
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				// console.log(this.tableData);
				this.total = response.total;
				this.loading = false;
				this.cancelChoose();
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.lesseeNameOptions = response.data;
			},
			cancelChoose() {
				this.$refs.openAccountRecordTable.setCurrentRow();
				this.currentRow = null;
			},
			// 新增 商户电表 对话框
			async addElectricMeterDialog() {
				this.newMeterFlag = true;
				this.addElectricForm = {};
				this.startDegree = null;
				this.addElectricVis = true;
				await this.getSelectUnUseMeter();
			},
			// 新增商户水表对话框
			async addWaterMeterDialog() {
				this.newMeterFlag = true;
				this.addWaterVis = true;
				this.addWaterForm = {};
				this.startDegree = null;
				await this.getSelectUnUseWaterMeter();
			},
			// / 获取未绑定水表下拉列表数据
			async getSelectUnUseWaterMeter() {
				const res = await selectUnUseWaterMeter().then();
				this.waterMeterIdOptions = res.data;
			},
			// 新增电表按钮
			addNewElectricMeter() {
				this.newMeterFlag = false;
				this.addElectricForm = {};
				this.startDegree = null;
			},
			// 新增水表按钮
			addNewWaterMeter() {
				this.newMeterFlag = false;
				this.addWaterForm = {};
				this.startDegree = null;
			},
			openAccount() {
				this.$router.push({
					path: '/mainWindow/openAccount',
				});
			},
			async editAccount() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await this.viewDetail();
					this.editDialogVisible = true;
				}
			},
			// 编辑用户信息
			async viewDetail() {
				const res = await detail({
					id: this.currentRow,
				}).then();
				this.recordForm = res.data.openAccountHeadVo;
				if (this.recordForm.enableElectricAccountFlag == "1") {
					this.electricAccountFlag = false;

				} else {
					this.electricAccountFlag = true;
				}
				if (this.recordForm.enableWaterAccountFlag == "1") {
					this.waterAccountFlag = false;
				} else {
					this.waterAccountFlag = true;
				}
				this.recordForm.districtId = cascaderAfferentArray(
					this.recordForm.districtData
				);
				this.electricTableData = res.data.openAccountBodyListVos;
				this.waterTableData = res.data.openAccountWaterBodyListVos;
			},
			// 单选表格某一行
			handleCurrentChange(val) {
				if (val == null) {
					return;
				} else {
					this.currentRow = val.id;
				}
			},

			// 已有编号电表 change事件
			async meterIdChange() {
				this.newMeterFlag = true;
				await this.getDetail();
			},
			// 根据已有编号 id 查询电表
			async getDetail() {
				const res = await meterDetail({
					id: this.addElectricForm.id,
				}).then();
				this.addElectricForm = res.data;
			},
			// 已有编号水表 change事件
			async waterMeterIdChange() {
				this.newMeterFlag = true;
				await this.getWaterMeterDetail();
			},
			// 根据已有编号 id 查询水表
			async getWaterMeterDetail() {
				const res = await detailWater({
					id: this.addWaterForm.id,
				}).then();
				this.addWaterForm = res.data;
			},
			// 电表查询
			async getSelectOne() {
				const res = await selectOne({
					id: this.addElectricForm.id,
				}).then();
				this.addElectricForm = res.data;
			},
			// 绑定 电表
			async bindElectricMeter() {
				this.$refs.addElectricForm.validate(async (valid) => {
					if (valid) {
						if (this.newMeterFlag) {
							await addMeter(this.addElectricForm).then();
							await this.getSelectOne();
						} else {
							const id = await addMeter(this.addElectricForm).then();
							this.addElectricForm.id = id.data;
							this.msgSuccess('新增电表成功');
						}
						for (let i = 0; i < this.electricTableData.length; i++) {
							if (this.addElectricForm.id == this.electricTableData[i].meterId) {
								return;
							}
						}
						let type = null;
						for (let i = 0; i < this.meterTypeOptions.length; i++) {
							if (this.addElectricForm.type == this.meterTypeOptions[i].key) {
								type = this.meterTypeOptions[i].value;
								console.log(type);
							}
						}
						let producer = null;
						for (let i = 0; i < this.producerOptions.length; i++) {
							if (this.addElectricForm.producer == this.producerOptions[i].key) {
								producer = this.producerOptions[i].value;
							}
						}
						let coulum = {
							meterId: this.addElectricForm.id,
							meterAddr: this.addElectricForm.meterAddr,
							model: this.addElectricForm.model,
							producer: producer || this.addElectricForm.producer,
							type: type || this.addElectricForm.type,
							startDegree: this.startDegree,
						};
						this.electricTableData.push(coulum);
						this.addElectricVis = false;
					} else {
						this.msgError('信息填写错误');
						return false;
					}
				});
			},
			// 水表查询
			async getSelectOneWater() {
				const res = await selectOneWater({
					id: this.addWaterForm.id,
				}).then();
				this.addWaterForm = res.data;
			},
			// 绑定 水表
			async bindWaterMeter() {
				this.$refs.addWaterForm.validate(async (valid) => {
					if (valid) {
						if (this.newMeterFlag) {
							await addWaterMeter(this.addWaterForm).then();
							await this.getSelectOneWater();
						} else {
							const id = await addWaterMeter(this.addWaterForm).then();
							this.addWaterForm.id = id.data;
							this.msgSuccess('新增水表成功');
						}
						let producer = null;
						for (let i = 0; i < this.waterProducerOptions.length; i++) {
							if (
								this.addWaterForm.producer == this.waterProducerOptions[i].key
							) {
								producer = this.waterProducerOptions[i].value;
							}
						}
						let coulum = {
							meterId: this.addWaterForm.id,
							meterAddr: this.addWaterForm.meterAddr,
							model: this.addWaterForm.model,
							producer: producer || this.addWaterForm.producer,
							startDegree: this.startDegree,
						};
						this.waterTableData.push(coulum);
						this.addWaterVis = false;
					} else {
						this.msgError('请填写必填项');
						return false;
					}
				});
			},
			// 保存编辑事件
			async editSaveClick() {
				this.$refs.recordForm.validate(async (valid) => {
					if (valid) {
						let res = this.recordForm;
						res.districtData = cascaderAfferentString(res.districtId);
						res.districtId = cascaderAfferentNumber(res.districtId);
						let params = {
							openAccountBodyVos: [],
							openAccountHeadVo: res,
							openAccountWaterBodyVos: [],
						};
						this.electricTableData.forEach((element) => {
							let bodyVos = {
								id: element.id,
								meterId: element.meterId,
								startDegree: element.startDegree,
							};
							params.openAccountBodyVos.push(bodyVos);
						});
						this.waterTableData.forEach((element) => {
							let bodyVos = {
								id: element.id,
								meterId: element.meterId,
								startDegree: element.startDegree,
							};
							params.openAccountWaterBodyVos.push(bodyVos);
						});

						await editSave(params).then();
						await this.handleQuery();
						this.msgSuccess('修改成功');
						this.recordForm = {
							code: '',
						};
						this.electricTableData = [];
						this.waterTableData = [];
						this.editDialogVisible = false;
					} else {
						this.msgError('信息填写错误');
						return false;
					}
				});
			},

			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('openAccountRecordTable', '开户记录');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			async handleViewDetail() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.detailDialogVisible = true;
					await this.viewDetail();
				}
			},

			// 获取业态下拉列表数据
			async getLesseeType() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.LESSEE_TYPE
				).then();
				this.lesseeTypeOptions = res.data;
			},
			// 获取未绑定电表下拉列表数据
			async getSelectUnUseMeter() {
				const res = await selectUnUseMeter().then();
				this.meterIdOptions = res.data;
			},
			// 获取下拉列表 数据
			async getWiringMode() {
				// 接线方式
				const res1 = await selectDictionaryListByName(
					dictionaryConstant.METER_CONNECT_TYPE
				).then();
				this.wiringModeOptions = res1.data;
			},
			async getProducer() {
				// 厂商类型
				const res2 = await selectMeterProducerList().then();
				this.producerOptions = res2.data;
			},
			async getSelectWaterProducerList() {
				// 水表厂商类型
				const res2 = await selectWaterProducerList().then();
				this.waterProducerOptions = res2.data;
			},
			async getMeterType() {
				// 电表制式
				const res3 = await selectDictionaryListByName(
					dictionaryConstant.METER_TYPE
				).then();
				this.meterTypeOptions = res3.data;
			},
			async getTerminalId() {
				// 终端类型
				const res4 = await selectMeterTerminalList().then();
				this.terminalOptions = res4.data;
			},
			async getSelectWaterTerminalList() {
				// 水表终端类型
				const res = await selectWaterTerminalList().then();
				this.terminalWaterOptions = res.data;
			},
			// 删除table当前行数据
			handleDeleteRow(index, rows) {
				rows.splice(index, 1);
			},
			// 区域下拉框
			async selectComboboxTreeData() {
				const res = await selectComboboxTreeData().then();
				this.districtIdOptions = res.data;
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
			// 单机开启电账户复选框改变事件
			electricAccountFlagChange(e) {
				if (e == "1") {
					this.electricAccountFlag = false;
					this.systemCustomConfigElectric();
				} else {
					this.electricAccountFlag = true;
					this.recordForm.electricPrice = 0;
				}
			},
			// 单机开启水账户复选框改变事件
			waterAccountFlagChange(e) {
				if (e == "1") {
					this.waterAccountFlag = false;
					this.systemCustomConfigWater();
				} else {
					this.waterAccountFlag = true;
					this.recordForm.waterPrice = 0;
				}
			},
			// 查询电费
			async systemCustomConfigElectric() {
				const res = await systemCustomConfig({
					dicKey: systemConstant.PRICE_ELECTRIC
				}).then();
				this.recordForm.electricPrice = res.data;
			},
			// 查询水费
			async systemCustomConfigWater() {
				const res = await systemCustomConfig({
					dicKey: systemConstant.PRICE_WATER
				}).then();
				this.recordForm.waterPrice = res.data;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	.searchForm {
		margin-top: 15px;

		/deep/ .el-form-item {
			margin-bottom: 10px;
		}
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
	}

	/deep/.el-dialog__body {
		padding: 10px !important;
	}

	.searchTag {
		width: 182px;
	}

	/deep/ .el-dialog {
		.el-form-item {
			// margin-bottom: 10px !important;
			width: 100%;
		}

		.el-input,
		.el-select {
			width: 100%;
		}
	}

	.tableStyle {
		height: calc(100% - 85px);
	}

	@media screen and (max-width: 1410px) {
		.tableStyle {
			height: calc(100% - 130px);
		}
	}

	/deep/ .el-cascader {
		width: 100%;
	}

	.detailDialogClass {
		/deep/ .el-form-item {
			margin-bottom: 10px !important;
		}

		/deep/ .el-card__header {
			padding: 10px 20px;
		}

		/deep/ .el-card__body {
			padding: 10px;
		}

		/deep/ .el-table .el-table__cell {
			padding: 6px 0;
		}
	}

	.block {
		margin-top: 15px;
	}

	//
</style>
